import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TooltipOnHover from './TooltipOnHover';

var ToolbarButton =
/*#__PURE__*/
function (_Component) {
  _inherits(ToolbarButton, _Component);

  function ToolbarButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ToolbarButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ToolbarButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      event.preventDefault();

      _this.props.onChange(_this.props.onClick);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      return _this.setState({
        hovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      return _this.setState({
        hovered: false
      });
    });

    return _this;
  }

  _createClass(ToolbarButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Icon = _this$props.icon,
          id = _this$props.id,
          tooltipTitle = _this$props.tooltipTitle,
          tooltipSubtitle = _this$props.tooltipSubtitle,
          active = _this$props.active,
          activeClassName = _this$props.activeClassName,
          inactiveClassName = _this$props.inactiveClassName;
      var hovered = this.state.hovered;
      return React.createElement(TooltipOnHover, {
        id: id,
        placement: "top",
        tooltipContent: React.createElement("div", null, React.createElement("div", {
          className: "font-size-normal padding-bottom-smaller"
        }, tooltipTitle), React.createElement("div", {
          className: "font-size-small"
        }, tooltipSubtitle))
      }, React.createElement("div", {
        className: classNames('pointer padding-vertical-small', 'flexbox flexbox-align-center flexbox-justify-center', 'toolbar-button', active || hovered ? activeClassName : inactiveClassName),
        onMouseDown: this.handleMouseDown,
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave
      }, Icon && React.createElement(Icon, {
        size: 16
      })));
    }
  }]);

  return ToolbarButton;
}(Component);

_defineProperty(ToolbarButton, "propTypes", {
  id: PropTypes.string,
  active: PropTypes.bool,
  icon: PropTypes.any,
  tooltipTitle: PropTypes.string,
  tooltipSubtitle: PropTypes.string,
  activeClassName: PropTypes.string,
  inactiveClassName: PropTypes.string,
  isActive: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func
});

_defineProperty(ToolbarButton, "defaultProps", {
  activeClassName: 'primary',
  inactiveClassName: 'shade-30'
});

export default ToolbarButton;